import * as React from "react";
import {
  Box,
  BoxProps,
} from "@advarra-engineering/advarra-design-system-react";
import { UIEvent } from "react";

interface ScrollToBottomBoxProps extends BoxProps {
  hasScrolled: boolean;
  onScrollToBottom: () => void;
}

/**
 * Dispatch an event when the user scrolls to the bottom of this element.
 * @param props
 * @returns
 */
export default function (props: ScrollToBottomBoxProps) {
  const { hasScrolled, onScrollToBottom, ...otherProps } = props;

  let scrollHandler = undefined;
  if (!hasScrolled) {
    scrollHandler = (e: UIEvent<HTMLElement>) => {
      const target = e.target as HTMLElement;

      if (
        target &&
        target.offsetHeight + target.scrollTop + marginForError >=
          target.scrollHeight
      ) {
        onScrollToBottom();
      }
    };
  }

  return <Box {...otherProps} onScroll={scrollHandler} />;
}

// Some values reported by browser may be rounded, if the scroll bar is 2 pixels away, go with it
const marginForError = 2;
